import React from "react";
import LettersPage from "../letter/LettersPage";
const RequestMissionPage = () => {
  return (
    <div>
      <LettersPage
        btn_add_disable={false}
        btn_edit_disable={false}
        btn_delete_disable={false}
        btn_print_disable={false}
        show_user_requests_div={true}
        user_requests_title={"ឈ្មោះមន្ត្រីស្នើបញ្ជាបេសកកម្ម"}
        car_support_by={"ថវិការដ្ឋ"}
        option_filter={"requestmission"}
        res_url={"lettersmissionrequests"}
        prepare_by_title={"បេសកកម្មយោង​ ឬសកម្មភាព ឬផែនការ ៖ "}
        user_requests_print_disable={true}
        car_lettertype={"លិខិតឧទ្ទេសនាមបេសកកម្ម"}
        type_letter_in_out={"ចេញ"}
        // GetUserName={getUser.username}
        // GetIdnumber={getUser.idnumber}
      />
    </div>
  );
};

export default RequestMissionPage;
